<template>
  <el-form
    ref="form"
    label-position="right"
    :model="form"
    :rules="rules"
    label-width="110px"
  >
    <el-form-item label="服务器类型" prop="apiId">
      <el-radio-group v-model="form.apiId">
        <el-radio
          v-for="server in serverList"
          :label="server.id"
          :key="server.id"
          style="margin-top: 10px"
        >{{ server.apiName }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      label="机器人名称"
      prop="botName"
    >
      <el-input
        placeholder="机器人名称"
        v-model="form.botName"
      ></el-input>
    </el-form-item>
    <el-form-item
      prop="monitorStatus"
      label="监听状态"
    >
      <el-radio-group
        v-model="form.monitorStatus"
      >
        <el-radio
          v-for="(type, index) in monitorStatusList"
          :label="type.key"
          :key="type.key"
        >{{ type.name }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      prop="botStatus"
      label="状态"
    >
      <el-radio-group
        v-model="form.botStatus"
      >
        <el-radio
          v-for="(type, index) in botStatusList"
          :label="type.key"
          :key="index"
        >{{ type.name }}</el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item
      label="remark"
      prop="remark"
    >
      <el-input
        v-model="form.remark"
        placeholder="备注"
      ></el-input>
    </el-form-item>

  </el-form>
</template>

<script>
import {validatEmail,isMobile} from "@/utils/validate";
let origin = {
  apiId: '',
  botName: '',
  monitorStatus: '',
  botStatus: '',
  remark: '',
}
export default {
  name: "wechatListForm",
  props: {
    formData:{
      type: Object,
      default(){
        return {
          id: ''
        };
      }
    }
  },
  data() {
    return {
      serverList:[],
      botStatusList: [
        {key:0,name:'禁用'},
        {key:1,name:'启用'}
      ],
      monitorStatusList: [
        {key:0,name:'不监听'},
        {key:1,name:'监听'}
      ],
      form: JSON.parse(JSON.stringify(origin)),
      rules: {
        apiId: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
        botName: [
          { required:true, message: '请输入', trigger: 'blur' },
        ],
        monitorStatus: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
        botStatus: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
        /*remark: [
          { required:true, message: '手机不能为空', trigger: 'blur' },
        ],*/
      },
    }
  },
  watch:{
    formData:{
      handler(newValue){
        if(newValue.id){
          this.assigen(newValue);
        }
      },
      deep: true,
    }
  },
  created(){
    this.getServerList();
  },
  methods: {
    getServerList() {
      this.$http({
        url: '/wx/manage/wxBotApiConfig/list',
        method: 'get',
        params: {
          'page': 1,
          'limit': 1000
        }
      }).then((res) => {
        if (res && res.code === 200) {
          this.serverList = res.page.list
        }
      })
    },
    reset(){
      this.form = JSON.parse(JSON.stringify(origin));
    },
    assigen(data){
      this.form.id = data.id;
      this.form.apiId = data.apiId;
      this.form.botName = data.botName;
      this.form.monitorStatus = data.monitorStatus;
      this.form.botStatus = data.botStatus;
      this.form.remark =data.remark;
    },
    // 菜单树设置当前选中节点
    // 上级菜单有时候编辑的时候没有对得上,有点问题, todo

    selfValidate() {
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }else {
          console.log('no-pass');
        }
      })
    },
    selfClear(){
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
  },
}
</script>

<style scoped>

</style>
